import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { FinalAccountPage } from '@/features/commercial/final-account-page';

const searchSchema = z.object({
  tab: z.enum(['account', 'reconciliation']).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/commercial/final-account')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <FinalAccountPage projectId={projectId} tab={search.tab} />;
}
